<template
  ><svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7_230)">
      <path
        d="M11.1375 3.53C10.794 4.10941 10.1617 4.49875 9.44003 4.49875H7.29984C6.21291 4.49875 5.32861 3.61557 5.32861 2.53V1.62997C5.47619 1.61023 5.62674 1.60004 5.77964 1.60004H10.9611C11.1127 1.60004 11.2619 1.61005 11.4083 1.62945V2.53H11.4113C11.4113 2.56669 11.4102 2.60314 11.4083 2.63934C11.3904 2.96308 11.2939 3.26624 11.1375 3.53Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.4113 2.53V1.92683C13.551 2.46984 14.3404 3.6321 14.3404 4.97504V12.625C14.3404 14.486 12.8245 16 10.9611 16H5.77964C3.91632 16 2.40039 14.486 2.40039 12.625V4.97504C2.40039 3.63246 3.18939 2.47046 4.32861 1.92726V2.53C4.32861 4.16904 5.66181 5.49875 7.29984 5.49875H9.44003C11.0781 5.49875 12.4113 4.16904 12.4113 2.53ZM6.23026 11.4752H10.9894C11.3004 11.4752 11.5526 11.2233 11.5526 10.9127C11.5526 10.602 11.3004 10.3502 10.9894 10.3502H6.23026C5.9192 10.3502 5.66706 10.602 5.66706 10.9127C5.66706 11.2233 5.9192 11.4752 6.23026 11.4752ZM10.9894 8.18455C11.3004 8.18455 11.5526 8.43638 11.5526 8.74705C11.5526 9.05772 11.3004 9.30955 10.9894 9.30955H9.89111C9.58005 9.30955 9.32791 9.05772 9.32791 8.74705C9.32791 8.43638 9.58005 8.18455 9.89111 8.18455H10.9894ZM8.88303 7.8833L7.80161 8.9727C7.58602 9.18994 7.29898 9.30955 6.99333 9.30955C6.68773 9.30955 6.40069 9.18991 6.18507 8.9727L5.66128 8.44504C5.44231 8.22443 5.44383 7.86829 5.66472 7.64956C5.88561 7.43083 6.2422 7.43235 6.46121 7.65299L6.98499 8.18064C6.99012 8.18579 6.99651 8.18582 7.00166 8.18064L8.08311 7.09125C8.30214 6.87061 8.65873 6.86912 8.87959 7.08782C9.10051 7.30654 9.10203 7.66269 8.88303 7.8833Z"
        :fill="color"
      />
      <path
        d="M9.57425 4.49424C10.2396 4.44934 10.8155 4.0732 11.1375 3.53C11.2939 3.26624 11.3904 2.96308 11.4083 2.63934C11.4102 2.60314 11.4113 2.56669 11.4113 2.53H11.4083V1.518C11.4083 1.23869 11.1813 1.012 10.9016 1.012H9.8012C9.59247 0.423016 9.02909 0 8.36843 0C7.70778 0 7.1444 0.423016 6.93465 1.012H5.83525C5.55559 1.012 5.32861 1.23869 5.32861 1.518V2.53C5.32861 3.61557 6.21291 4.49875 7.29984 4.49875H9.44003C9.48513 4.49875 9.52989 4.49723 9.57425 4.49424Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_7_230">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
